import type { CSSProperties } from 'react'

/** The accent colour the public course pages use for links and buttons. */
export function brandVars(b: { primaryColour: string | null; secondaryColour: string | null }): CSSProperties {
  return { '--brand-accent': b.secondaryColour || b.primaryColour || '#4F46E5' } as CSSProperties
}

const HEX = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i

/** A colour typed into an embed address ("1d4ed8" or "#1d4ed8") as a safe "#rrggbb" value, or null if it is not one. */
export function cleanColour(value: string | null | undefined): string | null {
  const v = value?.trim()
  if (!v || !HEX.test(v)) return null
  return v.startsWith('#') ? v : `#${v}`
}

/** The accent for an embed: the colour in the address if there is one, else the customer's own brand colour. */
export function embedAccentVars(b: { primaryColour: string | null; secondaryColour: string | null }, colour: string | null): CSSProperties {
  return { '--brand-accent': colour || b.secondaryColour || b.primaryColour || '#4F46E5' } as CSSProperties
}
